import * as React from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Header, Modal } from "semantic-ui-react";
import { Text } from "../components/common";
import { FILES_PATH } from "../constants";

interface IM004QandA extends WithTranslation {
  trigger: any;
}

class M004QandA extends React.Component<
  IM004QandA
> {
  public render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <Modal trigger={this.props.trigger} closeIcon size={"small"}>
          <Modal.Header>
            <Header shade={2} textAlign={"center"}>
              {t("modal.M004QandA.header")}
            </Header>
          </Modal.Header>
          <Modal.Content scrolling style={styles.modalContentStyle}>
            <Modal.Description style={styles.modalDescriptionStyle}>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.qa1}
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m004-qa-qa1"}
                      underline
                      shade={5}
                    >
                      {t("modal.M004QandA.qa1")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.qa2}
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m004-qa-qa2"}
                      underline
                      shade={5}
                    >
                      {t("modal.M004QandA.qa2")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.qa3}
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m004-qa-qa3"}
                      underline
                      shade={5}
                    >
                      {t("modal.M004QandA.qa3")}
                    </Text>
                  </Link>
                </Text>
              </div>
              <div>
                <Text shade={3} style={styles.spanStyle}>
                  <Link
                    target="_blank"
                    to={FILES_PATH.qa4}
                    style={styles.link}
                  >
                    <Text
                      id={"link-label-m004-qa-qa4"}
                      underline
                      shade={5}
                    >
                      {t("modal.M004QandA.qa4")}
                    </Text>
                  </Link>
                </Text>
              </div>
            </Modal.Description>
          </Modal.Content>
        </Modal>
      </React.Fragment>
    );
  }
}

const styles: any = {
  spanStyle: {
    // whiteSpace: "pre-wrap",
    whiteSpace: "pre-line"
  },
  addressStyle: {
    marginLeft: 42
  },
  displayInline: {
    display: "inline"
  },
  modalDescriptionStyle: {
    lineHeight: 1.8
  },
  modalContentStyle: {
    padding: 42
  },
  link: {
    opacity: "inherit"
  }
};

export default withTranslation()(M004QandA);
